<template>
  <div>
    <div class="container-fluid my-2">
      <div class="card-body">
        <div class="panel-body">
          <MultiSelectionPicker
            :all-items="availables"
            :allow-item-list-editing="!readOnly"
            :column-count="1"
            item-type-name="Fortaleza"
            maxlength="1500"
            :modify-removes-item="true"
            :selected-items="selectedItems"
            @itemAdded="addNewStrength"
            @itemDeleted="deletedStrength"
            @itemModified="editStrength"
          />

          <div class="row mt-3">
            <div class="col-12">
              <Error
                is-alert-mode
                message="Puede seleccionar una(1) o más fortalezas. Selección múltiple."
              />
            </div>
          </div>
          <CustomChipsGroup
            :disabled="readOnly"
            no-background
            no-wrap
            object-text="name"
            :on-item-deleted="removeSelection"
            :selected-items="selectedItems"
            title="Fortalezas Seleccionadas"
          />
        </div>
      </div>
    </div>
    <div class="actions">
      <ActionButton
        v-if="!readOnly"
        i="fas fa-save"
        variant="success m-2"
        @click="save"
      >
        Guardar
      </ActionButton>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import MultiSelectionPicker from '@/components/common/MultiSelectionPicker';
import CustomChipsGroup from 'CustomChipsGroup';
import Error from '@/components/common/Error';
import alertMixin from '@/mixins/alert.mixin.js';
import {
  getMeasureBankByUser as _getMeasureBankByUser,
  saveMeasureBankForUser as _saveMeasureBankForUser,
  deleteMeasureBankForUser as _deleteMeasureBankForUser,
} from '@/modules/referralManagement/api';
import MEASUREBANKTYPES from '@/utils/constants/measureBankTypes';

export default {
  name: 'StrenghtSelection',
  components: {
    ActionButton,
    MultiSelectionPicker,
    CustomChipsGroup,
    Error,
  },
  mixins: [alertMixin],
  props: {
    strengths: {
      type: Array,
      default: new Array(),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disciplineTypeId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      availableStrengths: [],
      selectedItems: [],
      deletedStrengths: [],
      idCounter: 0,
    };
  },
  computed: {
    availables() {
      return this.availableStrengths.filter(
        (x) => !this.selectedItems.some((s) => s.name === x.name)
      );
    },
  },
  watch: {
    strengths(val) {
      if (val.length > 0) {
        this.selectedItems = this.strengths.map((s) => ({
          id: s.id,
          name: s.description,
        }));
        this.save();
      }
    },
  },
  async mounted() {
    // get saved needs for current user
    await this.getMeasureBankByUser();
  },

  methods: {
    removeSelection(item) {
      let editedItemIndex = this.selectedItems.findIndex(
        (e) => e.id === item.id
      );
      this.selectedItems.splice(editedItemIndex, 1);
    },
    editStrength(item, index) {
      if (item.id > 0) {
        item.isDirty = true;
      }
      this.availableStrengths.splice(index, 0, item);
    },
    async addNewStrength(itemText) {
      const { data: response } = await _saveMeasureBankForUser({
        measureTypeId: MEASUREBANKTYPES.Fortalezas,
        disciplineTypeId: this.disciplineTypeId,
        description: itemText,
      });
      this.availableStrengths.push({
        id: response.id,
        name: response.name,
      });
    },
    async deletedStrength(item) {
      let alertResponse = await this.ShowCancelModal(
        'Atención',
        '¿Esta seguro que desea eliminar la fortaleza "' + item.name + '"?',
        'Aceptar',
        'Cancelar'
      );

      if (alertResponse) {
        let removedItemIndex = this.availableStrengths.findIndex(
          (e) => e.id === item.id
        );
        this.availableStrengths.splice(removedItemIndex, 1);
        this.deletedStrengths.push(item);
        await _deleteMeasureBankForUser(item.id);
      }
    },
    async save() {
      this.$emit('save-strengths', this.selectedItems);
    },
    async getMeasureBankByUser() {
      const { data: response } = await _getMeasureBankByUser(
        this.disciplineTypeId
      );
      if (response && response.length > 0) {
        this.availableStrengths = response.filter(
          (x) => x.measureTypeId === MEASUREBANKTYPES.Fortalezas
        );
      }
    },
  },
};
</script>
<style scoped>
.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
